import {
  ASN_TO_BERGEN_REQUEST,
  ASN_TO_BERGEN_SUCCESS,
  ASN_TO_BERGEN_ERROR
  } from "../actions/types";
  
  export const asnToBergen = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case   ASN_TO_BERGEN_REQUEST:
        return {
          loading: true,
        };
      case   ASN_TO_BERGEN_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case   ASN_TO_BERGEN_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  